module.exports = __webpack_public_path__ + "img/SETTING.b6ac829a.svg";